var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.item,
          expression: "item",
        },
      ],
      class: _vm.question.cssClasses.previewItem,
      on: {
        click: function ($event) {
          return _vm.question.doDownloadFileFromContainer($event)
        },
      },
    },
    [
      _vm.item.name && _vm.question.cssClasses.fileSign
        ? _c("div", { class: _vm.question.cssClasses.fileSign }, [
            _c(
              "a",
              {
                style: { width: _vm.question.imageWidth },
                attrs: {
                  href: _vm.item.content,
                  title: _vm.item.name,
                  download: _vm.item.name,
                },
                on: {
                  click: function ($event) {
                    return _vm.question.doDownloadFile($event, _vm.item)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.item.name))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.question.getImageWrapperCss(_vm.item) },
        [
          _vm.question.canPreviewImage(_vm.item)
            ? _c("img", {
                style: {
                  height: _vm.question.imageHeight,
                  width: _vm.question.imageWidth,
                },
                attrs: { src: _vm.item.content, alt: "File preview" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.question.defaultImage(_vm.item)
            ? _c("sv-svg-icon", {
                class: _vm.question.cssClasses.defaultImage,
                attrs: {
                  iconName: _vm.question.cssClasses.defaultImageIconId,
                  size: "auto",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.item.name && !_vm.question.isReadOnly
            ? _c(
                "div",
                {
                  class: _vm.question.getRemoveButtonCss(),
                  on: {
                    click: function ($event) {
                      return _vm.question.doRemoveFile(_vm.item, $event)
                    },
                  },
                },
                [
                  _c("span", { class: _vm.question.cssClasses.removeFile }, [
                    _vm._v(_vm._s(_vm.question.removeFileCaption)),
                  ]),
                  _vm._v(" "),
                  _vm.question.cssClasses.removeFileSvgIconId
                    ? _c("sv-svg-icon", {
                        class: _vm.question.cssClasses.removeFileSvg,
                        attrs: {
                          title: _vm.question.removeFileCaption,
                          iconName: _vm.question.cssClasses.removeFileSvgIconId,
                          size: "auto",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.item.name && _vm.question.cssClasses.fileSignBottom
        ? _c("div", { class: _vm.question.cssClasses.fileSignBottom }, [
            _c(
              "a",
              {
                style: { width: _vm.question.imageWidth },
                attrs: {
                  href: _vm.item.content,
                  title: _vm.item.name,
                  download: _vm.item.name,
                },
                on: {
                  click: function ($event) {
                    return _vm.question.doDownloadFile($event, _vm.item)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.item.name))]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }